'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _providerCard = require('./providerCard.scss');

var _providerCard2 = _interopRequireDefault(_providerCard);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _Button = require('wix-style-react/dist/src/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Tooltip = require('wix-style-react/dist/src/Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _v = require('-!svg-react-loader!../../../assets/images/change-provider/v.svg');

var _v2 = _interopRequireDefault(_v);

var _info = require('-!svg-react-loader!../../../assets/images/fullscreen-store/info.svg');

var _info2 = _interopRequireDefault(_info);

var _ChangeProviderLink = require('./ChangeProviderLink');

var _ChangeProviderLink2 = _interopRequireDefault(_ChangeProviderLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_providerCard2.default);

var ProviderCard = function ProviderCard(props) {
  var provider = props.provider,
      isActive = props.isActive,
      onLearnMore = props.onLearnMore,
      icon = props.icon,
      onClick = props.onClick,
      onSupportLink = props.onSupportLink,
      t = props.t;
  var _provider$languageKey = provider.languageKeys,
      sellTypeKey = _provider$languageKey.sellTypeKey,
      sellDescriptionKey = _provider$languageKey.sellDescriptionKey,
      sellTypeButtonKey = _provider$languageKey.sellTypeButtonKey,
      nameCartKey = _provider$languageKey.nameCartKey;


  var ctaBottom = null;
  if (isActive) {
    ctaBottom = _react2.default.createElement(
      'div',
      { className: _providerCard2.default.activatedSection },
      _react2.default.createElement(
        'div',
        { className: _providerCard2.default.activeIcon },
        (0, _v2.default)({ width: '14px', height: '12px' })
      ),
      _react2.default.createElement(
        'span',
        { className: _providerCard2.default.activated },
        t.getByKey('ChangeProvider_Switching_PopUp_Selected')
      )
    );
  } else {
    ctaBottom = _react2.default.createElement(
      'div',
      { className: _providerCard2.default.activateButton },
      _react2.default.createElement(
        _Button2.default,
        null,
        t.getByKey(sellTypeButtonKey)
      )
    );
  }

  var tooltip = null;
  var balancertooltip = null;
  var learnMoreLink = null;

  var tooltipRef = void 0;
  if (provider.supportLink) {
    tooltip = _react2.default.createElement(
      _Tooltip2.default,
      {
        ref: function ref(_ref) {
          tooltipRef = _ref;
        },
        hideDelay: 400,
        placement: 'bottom',
        textAlign: 'left',
        content: _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(_ChangeProviderLink2.default, {
            onClick: function onClick(e) {
              try {
                tooltipRef.hide();
              } catch (error) {
                console.error('error hiding tooltip on click', error);
              }
              onSupportLink(e);
            },
            text: t.getByKey('ChangeProvider_Switch_Screen_OrderAPrint_Tooltip_Link')
          }),
          ' ',
          t.getByKey('ChangeProvider_Switch_Screen_OrderAPrint_Tooltip') + ' ' + t.getByKey(nameCartKey),
          '.'
        ),
        showTrigger: 'mouseenter',
        hideTrigger: 'mouseleave',
        maxWidth: '220px'
      },
      _react2.default.createElement(
        'div',
        { className: _providerCard2.default.tooltip },
        (0, _info2.default)({ onClick: function onClick(e) {
            return onSupportLink(e);
          } })
      )
    );
    balancertooltip = _react2.default.createElement(
      'div',
      { className: _providerCard2.default.tooltip },
      '\xA0'
    );
  }
  learnMoreLink = _react2.default.createElement(_ChangeProviderLink2.default, {
    onClick: onLearnMore,
    text: t.getByKey('ChangeProvider_Switch_Screen_Provider_Wix_LearnMore_Label')
  });

  return _react2.default.createElement(
    'div',
    { className: cx(_providerCard2.default.container, { active: isActive }), onClick: onClick },
    _react2.default.createElement(
      'div',
      { className: _providerCard2.default.content },
      _react2.default.createElement(
        'div',
        { className: _providerCard2.default.icon },
        icon
      ),
      _react2.default.createElement(
        'span',
        { className: _providerCard2.default.sellingType },
        t.getByKey(sellTypeKey)
      ),
      _react2.default.createElement(
        'span',
        { className: _providerCard2.default.fulfilled },
        balancertooltip,
        t.getByKey('ChangeProvider_Switch_Screen_Fulfilled_By'),
        '\xA0',
        t.getByKey(nameCartKey),
        ' ',
        tooltip
      ),
      _react2.default.createElement(
        'span',
        { className: _providerCard2.default.descriptionSection },
        _react2.default.createElement(
          'span',
          { className: _providerCard2.default.description },
          t.getByKey(sellDescriptionKey)
        ),
        '\xA0',
        learnMoreLink
      ),
      ctaBottom
    )
  );
};

ProviderCard.propTypes = {
  provider: _propTypes2.default.any,
  isActive: _propTypes2.default.any,
  onClick: _propTypes2.default.any,
  onLearnMore: _propTypes2.default.any,
  icon: _propTypes2.default.any,
  onSupportLink: _propTypes2.default.func,
  t: _propTypes2.default.object
};

exports.default = ProviderCard;